var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 41,
    viewBox: "0 0 44 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4489 28.1671C-1.87923 29.648 -0.398324 13.358 11.4489 14.8389C7.00622 -1.45112 32.1817 -1.45112 30.7008 10.3962C45.5098 5.95343 45.5098 29.648 32.1817 28.1671M14.4108 22.2434L21.8153 16.3198M21.8153 16.3198L29.2199 22.2434M21.8153 16.3198V38.5334",
    stroke: "#626262",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.2683f5c5abdf8ab4ad6bdedee0677e34.svg";
export { ForwardRef as ReactComponent };